import _styled from "@emotion/styled/base";
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useConfiguration } from '@travel-frontend/core';
import Base64 from 'crypto-js/enc-base64';
import Utf8 from 'crypto-js/enc-utf8';
import hmacSHA512 from 'crypto-js/hmac-sha512';
import { Children, cloneElement, isValidElement } from 'react';
import { Form } from '../../../components/internal/MaskedLink/components/Form.js';
const MaskedLinkComponent = ({
  enabled = true,
  children,
  href,
  target,
  className,
  rel,
  ownFocus = false,
  onClick
}) => {
  const maskingKey = useConfiguration('linkMaskingKey');
  if (!href) {
    return _jsx(_Fragment, {
      children: children
    });
  }
  // Bypass if the masking key is not set in the consuming app
  if (!maskingKey || !enabled) {
    return _jsx(_Fragment, {
      children: Children.map(children, child => {
        if (isValidElement(child)) {
          return cloneElement(child, {
            // @ts-expect-error TS(2769) FIXME: No overload matches this call.
            as: 'a',
            href,
            target,
            className,
            rel,
            onClick
          });
        }
        return child;
      })
    });
  }
  return _jsxs(Form, {
    className: className || '',
    target: target || '_self',
    method: "post",
    action: `/api/instant/redirect`,
    rel: rel,
    ownFocus: ownFocus,
    onClick: onClick,
    children: [href && _jsx("input", {
      type: "hidden",
      name: "url",
      value: Base64.stringify(Utf8.parse(href))
    }), _jsx("input", {
      type: "hidden",
      name: "h",
      value: Base64.stringify(hmacSHA512(href, maskingKey))
    }), _jsx("button", {
      type: "submit",
      children: children
    })]
  });
};
export const MaskedLink = /*#__PURE__*/_styled(MaskedLinkComponent, process.env.NODE_ENV === "production" ? {
  target: "enbe8fg0"
} : {
  target: "enbe8fg0",
  label: "MaskedLink"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImluZGV4LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWdDc0QiLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBGcmFnbWVudCBhcyBfRnJhZ21lbnQsIGpzeCBhcyBfanN4LCBqc3hzIGFzIF9qc3hzIH0gZnJvbSBcIkBlbW90aW9uL3JlYWN0L2pzeC1ydW50aW1lXCI7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgeyB1c2VDb25maWd1cmF0aW9uIH0gZnJvbSAnQHRyYXZlbC1mcm9udGVuZC9jb3JlJztcbmltcG9ydCBCYXNlNjQgZnJvbSAnY3J5cHRvLWpzL2VuYy1iYXNlNjQnO1xuaW1wb3J0IFV0ZjggZnJvbSAnY3J5cHRvLWpzL2VuYy11dGY4JztcbmltcG9ydCBobWFjU0hBNTEyIGZyb20gJ2NyeXB0by1qcy9obWFjLXNoYTUxMic7XG5pbXBvcnQgeyBDaGlsZHJlbiwgY2xvbmVFbGVtZW50LCBpc1ZhbGlkRWxlbWVudCB9IGZyb20gJ3JlYWN0JztcbmltcG9ydCB7IEZvcm0gfSBmcm9tICcuLi8uLi8uLi9jb21wb25lbnRzL2ludGVybmFsL01hc2tlZExpbmsvY29tcG9uZW50cy9Gb3JtLmpzJztcbmNvbnN0IE1hc2tlZExpbmtDb21wb25lbnQgPSAoeyBlbmFibGVkID0gdHJ1ZSwgY2hpbGRyZW4sIGhyZWYsIHRhcmdldCwgY2xhc3NOYW1lLCByZWwsIG93bkZvY3VzID0gZmFsc2UsIG9uQ2xpY2ssIH0pID0+IHtcbiAgICBjb25zdCBtYXNraW5nS2V5ID0gdXNlQ29uZmlndXJhdGlvbignbGlua01hc2tpbmdLZXknKTtcbiAgICBpZiAoIWhyZWYpIHtcbiAgICAgICAgcmV0dXJuIF9qc3goX0ZyYWdtZW50LCB7IGNoaWxkcmVuOiBjaGlsZHJlbiB9KTtcbiAgICB9XG4gICAgLy8gQnlwYXNzIGlmIHRoZSBtYXNraW5nIGtleSBpcyBub3Qgc2V0IGluIHRoZSBjb25zdW1pbmcgYXBwXG4gICAgaWYgKCFtYXNraW5nS2V5IHx8ICFlbmFibGVkKSB7XG4gICAgICAgIHJldHVybiAoX2pzeChfRnJhZ21lbnQsIHsgY2hpbGRyZW46IENoaWxkcmVuLm1hcChjaGlsZHJlbiwgKGNoaWxkKSA9PiB7XG4gICAgICAgICAgICAgICAgaWYgKGlzVmFsaWRFbGVtZW50KGNoaWxkKSkge1xuICAgICAgICAgICAgICAgICAgICByZXR1cm4gY2xvbmVFbGVtZW50KGNoaWxkLCB7XG4gICAgICAgICAgICAgICAgICAgICAgICAvLyBAdHMtZXhwZWN0LWVycm9yIFRTKDI3NjkpIEZJWE1FOiBObyBvdmVybG9hZCBtYXRjaGVzIHRoaXMgY2FsbC5cbiAgICAgICAgICAgICAgICAgICAgICAgIGFzOiAnYScsXG4gICAgICAgICAgICAgICAgICAgICAgICBocmVmLFxuICAgICAgICAgICAgICAgICAgICAgICAgdGFyZ2V0LFxuICAgICAgICAgICAgICAgICAgICAgICAgY2xhc3NOYW1lLFxuICAgICAgICAgICAgICAgICAgICAgICAgcmVsLFxuICAgICAgICAgICAgICAgICAgICAgICAgb25DbGljayxcbiAgICAgICAgICAgICAgICAgICAgfSk7XG4gICAgICAgICAgICAgICAgfVxuICAgICAgICAgICAgICAgIHJldHVybiBjaGlsZDtcbiAgICAgICAgICAgIH0pIH0pKTtcbiAgICB9XG4gICAgcmV0dXJuIChfanN4cyhGb3JtLCB7IGNsYXNzTmFtZTogY2xhc3NOYW1lIHx8ICcnLCB0YXJnZXQ6IHRhcmdldCB8fCAnX3NlbGYnLCBtZXRob2Q6IFwicG9zdFwiLCBhY3Rpb246IGAvYXBpL2luc3RhbnQvcmVkaXJlY3RgLCByZWw6IHJlbCwgb3duRm9jdXM6IG93bkZvY3VzLCBvbkNsaWNrOiBvbkNsaWNrLCBjaGlsZHJlbjogW2hyZWYgJiYgKF9qc3goXCJpbnB1dFwiLCB7IHR5cGU6IFwiaGlkZGVuXCIsIG5hbWU6IFwidXJsXCIsIHZhbHVlOiBCYXNlNjQuc3RyaW5naWZ5KFV0ZjgucGFyc2UoaHJlZikpIH0pKSwgX2pzeChcImlucHV0XCIsIHsgdHlwZTogXCJoaWRkZW5cIiwgbmFtZTogXCJoXCIsIHZhbHVlOiBCYXNlNjQuc3RyaW5naWZ5KGhtYWNTSEE1MTIoaHJlZiwgbWFza2luZ0tleSkpIH0pLCBfanN4KFwiYnV0dG9uXCIsIHsgdHlwZTogXCJzdWJtaXRcIiwgY2hpbGRyZW46IGNoaWxkcmVuIH0pXSB9KSk7XG59O1xuZXhwb3J0IGNvbnN0IE1hc2tlZExpbmsgPSBzdHlsZWQoTWFza2VkTGlua0NvbXBvbmVudCkgYGA7XG4vLyMgc291cmNlTWFwcGluZ1VSTD1pbmRleC5qcy5tYXAiXX0= */");